import Images from '~/../assets/images';

export default brand => Images[`flag_${brand}`] || Images.flag_default;
